import { css } from '@emotion/react';

export const brandUpdateCoachMessageStyles = {
  layout: css`
    display: flex;
    gap: var(--cds-spacing-100);
    align-items: flex-start;
  `,
  sparkleIconContainer: css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: var(--cds-border-radius-max);
    background: var(--cds-color-emphasis-primary-background-xweak);
    flex-shrink: 0;
  `,
  content: css`
    flex: 1;
    min-width: 0;
  `,
};
